export enum PmsType {
    Mews = 'MEWS_API',
    Apaleo = 'APALEO',
    OperaCloud = 'OPERA_CLOUD',
    OperaLegacy = 'OPERA_RES_V02',
    Sciant = 'SCIANT',
    Emma = 'EMMA',
    Hilton = 'HILTON',
    HotelKey = 'HOTELKEY',
    Guestline = 'GUESTLINE',
    Shiji = 'SHIJI_API',
    StayNTouch = 'StayNTouch',
    Hapi = 'HAPI_API',
    Ideas = 'IDEAS',
    Gim = 'GIM',
}

export interface PmsSetup {
    type: PmsType;
}

export interface MewsPmsSetup extends PmsSetup {
    type: PmsType.Mews;
    apiToken: string;
}

export interface OperaCloudSsdPmsSetup extends PmsSetup {
    type: PmsType.OperaCloud;
    path: 'SSD';
    chainCode: string;
    propertyCode: string;
    hotelLoginLink: string;
    externalSystemCode: string;
}

export interface OperaCloudOcimPmsSetup extends PmsSetup {
    type: PmsType.OperaCloud;
    path: 'OCIM';
    enterpriseId: string;
    chainId: string;
    propertyId: string;
    hotelLoginLink: string;
}

export interface GuestlinePmsSetup extends PmsSetup {
    type: PmsType.Guestline;
    siteId: string;
    groupId: string;
}

export interface ShijiPmsSetup extends PmsSetup {
    type: PmsType.Shiji;
    tenantName: string;
    propertyId: string;
    username: string;
    password: string;
}

export interface StayNTouchPmsSetup extends PmsSetup {
    type: PmsType.StayNTouch;
    baseUrl: string;
    tokenUrl: string;
    hotelId: number;
    clientId: string;
    clientSecret: string;
}

const PMS_LABELS: Record<PmsType, string> = {
    StayNTouch: 'StayNTouch',
    MEWS_API: 'Mews',
    OPERA_RES_V02: 'Opera 5 (Legacy)',
    SCIANT: 'Opera 5',
    EMMA: 'Emma Radisson',
    HILTON: 'Hilton',
    HOTELKEY: 'HotelKey',
    GUESTLINE: 'Guestline',
    OPERA_CLOUD: 'Opera Cloud',
    SHIJI_API: 'Shiji',
    APALEO: 'Apaleo',
    HAPI_API: 'Infor HMS',
    IDEAS: 'IDeaS',
    GIM: 'GetIntoMore',
};

export function formatPmsType(type: PmsType): string {
    return PMS_LABELS[type] ?? type;
}
